import { ClickAwayListener } from '@material-ui/core';
import { equipmentFieldNameDictionary } from '@models/FieldConfiguration.model';
import { pick } from '@utils/pick';
import {
  Buttons,
  Container,
  Div,
  Header,
  Search,
  SearchContainer,
  ShowOptions,
  StyledOption,
} from './SearchBarExpansiveFieldConfigWithHeader.styles';

export interface ContentAndIdAndManufacturer {
  content: string;
  id: string;
  manufacturerName?: string;
}
interface SearchBarProps {
  showOptions?: string[];
  showCustomOptions?: string[];
  searchText?: string;
  isHidden?: boolean;
  handleClickSearch?: () => void;
  onClickFilter?: (input: string) => void;
}
const disableAddObject = pick(equipmentFieldNameDictionary, [
  'tags',
  'productCategory',
  'productStatus',
  'productWarranty',
]);
const OMIT_LIST = Object.values(disableAddObject);

const SearchBarExpansiveFieldConfigWithHeader = ({
  searchText,
  isHidden,
  showOptions,
  showCustomOptions,
  onClickFilter,
  handleClickSearch,
}: SearchBarProps) => {
  const handleClickAway = () => {
    // setShowOptions([]);
  };
  const haveOptions = showOptions ? showOptions.length > 0 : false;
  const haveCustomOptions = showCustomOptions
    ? showCustomOptions.length > 0
    : false;
  return (
    <Div haveResults={haveOptions || haveCustomOptions}>
      <SearchContainer>
        <Search
          data-testid="add-field"
          onClick={handleClickSearch}
          // disabled={isHidden}
          haveResults={!isHidden}
        >
          {searchText}
        </Search>
      </SearchContainer>
      {(haveOptions || haveCustomOptions) && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <ShowOptions haveResults={haveOptions || haveCustomOptions}>
            <Container
              data-testid="add-field-results"
              haveResults={haveOptions || haveCustomOptions}
            >
              {showOptions && showOptions.length > 0 && (
                <>
                  <Header>Default Fields</Header>
                  {showOptions
                    .filter(item => !OMIT_LIST.includes(item))
                    .map(item => (
                      <StyledOption
                        data-testid="add-field-default-field"
                        onClick={() => {
                          if (onClickFilter) onClickFilter(item);
                        }}
                      >
                        {item}
                      </StyledOption>
                    ))}
                </>
              )}
              {showCustomOptions && showCustomOptions.length > 0 && (
                <>
                  <Header>Custom Fields</Header>
                  {showCustomOptions.map(item => (
                    <StyledOption
                      onClick={() => {
                        if (onClickFilter) onClickFilter(item);
                      }}
                    >
                      {item}
                    </StyledOption>
                  ))}
                </>
              )}
            </Container>
            <Buttons />
          </ShowOptions>
        </ClickAwayListener>
      )}
    </Div>
  );
};

export { SearchBarExpansiveFieldConfigWithHeader };
